



























import Vue from 'vue'
import ProductItem from '@/stockLibrary/components/product/ProductItem.vue'

import { PRODUCT_REQUEST_LIMIT } from '@/stockLibrary/config/consts'
import {
  SimplifiedProductByCategory,
  FullColorCategory,
  FullColorProductsByCategoryRes
} from '@/stockLibrary/queries/types'
import { getProductsByCategory } from '@/stockLibrary/services'

export default Vue.extend({
  components: {
    ProductItem
  },
  props: {
    defaultProducts: {
      type: Array as () => SimplifiedProductByCategory[],
      required: true
    },
    selectedCategoryId: {
      type: String,
      required: true
    },
    selectedCategoryName: {
      type: String,
      required: true
    },
    selectedProductId: {
      type: String,
      required: true
    },
    categories: {
      type: Array as () => FullColorCategory[],
      required: true
    }
  },
  data(): {
    showCategoryModal: boolean
    products: SimplifiedProductByCategory[]
    loadingProductList: boolean
    hasMoreProduct: boolean
  } {
    return {
      showCategoryModal: false,
      products: [],
      loadingProductList: false,
      hasMoreProduct: this.defaultProducts.length <= PRODUCT_REQUEST_LIMIT
    }
  },
  watch: {
    selectedCategoryId(newVal: string, oldVal: string) {
      if (newVal && newVal !== oldVal) {
        this.products = []
      this.getProductListByCategory()
      }
    }
  },
  mounted() {
    this.products = [...this.defaultProducts]
  },
  methods: {
    onScroll({
      target: { scrollTop, clientHeight, scrollHeight, scrollLeft, clientWidth, scrollWidth }
    }) {
      const isScrollToBottom = scrollTop + clientHeight >= scrollHeight
      const isScrollToRight = scrollLeft + clientWidth >= scrollWidth
      if ((isScrollToBottom || isScrollToRight) && this.hasMoreProduct) {
        this.getProductListByCategory()
      }
    },
    selectProduct(id: string) {
      this.$emit('onSelectProduct', id)
    },
    async getProductListByCategory() {
      if (this.loadingProductList) return
      this.loadingProductList = true
      const data: FullColorProductsByCategoryRes = await getProductsByCategory({
        categoryId: this.selectedCategoryId,
        offset: this.products.length,
        limit: PRODUCT_REQUEST_LIMIT
      }).finally(() => {
        this.loadingProductList = false
      })
      if (data) {
        this.products.push(
          ...(data.fullColorProductsByCategory?.products || [])
        )
        this.hasMoreProduct =
          this.products.length <
          (data.fullColorProductsByCategory?.totalItemsCount || 0)
        this.$emit('onSelectProduct', this.products[0].id)
      }
    }
  }
})
